const TIMER_pad = (n) => String(n).padStart(2, '0');

const TIMER_digits = (str) =>
  str
    .split('')
    .map((d) => `<span>${d}</span>`)
    .join('');

const TIMER_label = (value, singular) => (value === 1 ? singular : `${singular}s`);

const TIMER_unit = (cls, value, label, labelClass) =>
  `<div class="${cls}-count"><p class="${cls}">${TIMER_digits(
    TIMER_pad(value)
  )}<h6 class="${labelClass}">${label}</h6></p></div>`;

const TIMER_markup = (totalSeconds) => {
  const days = Math.floor(totalSeconds / 86400);
  let rest = totalSeconds - days * 86400;
  const hours = Math.floor(rest / 3600);
  rest -= hours * 3600;
  const minutes = Math.floor(rest / 60);
  const seconds = rest - minutes * 60;

  const parts = [];
  if (days > 0) {
    parts.push(TIMER_unit('days', days, TIMER_label(days, 'Day'), 'timer-text1'));
  }
  parts.push(TIMER_unit('hours', hours, TIMER_label(hours, 'Hour'), 'timer-text1'));
  parts.push(TIMER_unit('minutes', minutes, TIMER_label(minutes, 'Min'), 'timer-text2'));
  parts.push(TIMER_unit('sec', seconds, TIMER_label(seconds, 'Sec'), 'timer-text3'));

  return parts.join('<span class="timer-dots">:</span>');
};

const TIMER_setup = (wrap) => {
  const display = wrap.querySelector('.count-down-timer-new');
  if (!display) return;

  const { startDate, endDate, renewDays } = wrap.dataset;

  const end = new Date(endDate);
  if (!endDate || Number.isNaN(end.getTime())) return;

  const startParsed = startDate ? new Date(startDate) : null;
  const start = startParsed && !Number.isNaN(startParsed.getTime()) ? startParsed : null;

  const renewMs = (parseInt(renewDays, 10) || 0) * 86400000;

  const endFor = (now) => {
    if (renewMs <= 0 || now <= end) return end;
    const periods = Math.floor((now - end) / renewMs);
    return new Date(end.getTime() + (periods + 1) * renewMs);
  };

  const tick = () => {
    const now = new Date();
    const upcoming = Boolean(start) && now < start;
    const remaining = Math.ceil(((upcoming ? start : endFor(now)) - now) / 1000);

    if (!upcoming && remaining <= 0) {
      wrap.classList.add('hide');
      return;
    }

    wrap.classList.remove('hide');
    wrap.classList.toggle('is-upcoming', upcoming);
    wrap.classList.toggle('is-live', !upcoming);
    display.innerHTML = TIMER_markup(Math.max(0, remaining));
  };

  tick();
  setInterval(tick, 1000);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.timer-wrap-new').forEach(TIMER_setup);
});
